import ProductAddonSection from './product-addon-section-view'

export default ProductAddonSection
